import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponentWithState} from '../../../base-components/orbit-component-with-state/orbit-component-with-state';
import {LanguageSwitcherDropdownComponent} from '../../../language-switcher-dropdown/language-switcher-dropdown.component';
import {HeaderLanguageSwitcherBox} from '../../boxes/language-switcher/header-language-switcher.box';
import { Button } from '../../../../basic-ui-components/button/base/button.component';
import {CyClass} from '../../../../../common/cy-classes';

export interface LanguageSwitcherComponentProps {}

export interface LanguageSwitcherComponentState {
  readonly isOpen: boolean
}

@observer
export class HeaderLanguageSwitcherComponent extends OrbitComponentWithState<LanguageSwitcherComponentProps, LanguageSwitcherComponentState> {
  private _timer: number;

  constructor(props: LanguageSwitcherComponentProps) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  private _toggleDropdown = () => {
    this._clearCollapseTimeout();
    this.setState({...this.state, isOpen: !this.state.isOpen});
  };

  private _colapseDropdown = () => {
    this.setState({...this.state, isOpen: false});
  };

  private _startCollapseTimeout = () => {
    this._timer = setTimeout(this._colapseDropdown, 300);
  };

  private _clearCollapseTimeout = () => {
    clearTimeout(this._timer);
  };

  render() {

    if(this.services.device.isMobile || this.services.language.languageSwitcher.isEmpty) {
      return null;
    }

    return (
      <HeaderLanguageSwitcherBox
        onMouseEnter={() => this._clearCollapseTimeout()}
        onMouseLeave={() => this._startCollapseTimeout()}
      >
        <Button
          preset="flatStroked"
          icon={{Component: this.services.theme.currentTheme.icons.earthGlobeIcon, size: "large"}}
          active={this.state.isOpen}
          onClick={() => this._toggleDropdown()}
          margin="0 0.4rem"
          className={CyClass("cy-language-switcher-button")}
        />
        <LanguageSwitcherDropdownComponent isOpen={this.state.isOpen}/>
      </HeaderLanguageSwitcherBox>
    );
  }
}


